import React from 'react'

import { LoadingPlaceholder } from '@sketch/components'

import { SubjectPreviewImage } from './InboxListItemPreview.styles'

interface ImagePreviewProps {
  alt: string
  src: string
}

export const ImagePreview = ({ alt, src }: ImagePreviewProps) => (
  <SubjectPreviewImage
    src={src}
    alt={alt}
    loadingPlaceholder={<LoadingPlaceholder />}
  />
)
